import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  display: flex;
  gap: ${tokens.spacing.horizontalMedium};
  align-items: center;
  width: 287px;
  padding: ${tokens.spacing.insetMedium};
  box-shadow: ${tokens.shadows.centerMedium};
  background-color: ${tokens.colors.white};
  border-top-right-radius: ${tokens.radius.xlarge};
  border-bottom-right-radius: ${tokens.radius.xlarge};
  border-bottom-left-radius: ${tokens.radius.xlarge};

  @media (min-width: ${tokens.breakpoints.desktop}px) {
    width: 367px;
  }
`

export const Image = styled.img`
  display: block;
  height: 86px;
`

export const Text = styled.p`
  flex: 1;
  color: ${tokens.colors.dark5};
  line-height: ${tokens.lineHeight.medium}%;
  font-size: ${tokens.fontSize.xsmall};
`
